
import { motion } from 'framer-motion';

const FireworkAnimation = ({ show }: { show: boolean }) => {
  if (!show) return null;

  // Create animated dots that burst from center and fade out
  const fireworks = Array.from({ length: 50 }).map((_, i) => {
    const size = Math.random() * 8 + 4;
    const angle = Math.random() * Math.PI * 2;
    const distance = Math.random() * 100 + 50;
    const duration = Math.random() * 2 + 1;
    const delay = Math.random() * 0.5;
    
    return (
      <motion.div
        key={i}
        className="absolute rounded-full"
        initial={{ 
          x: 0, 
          y: 0, 
          opacity: 1,
          background: `rgb(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)})`
        }}
        animate={{ 
          x: Math.cos(angle) * distance, 
          y: Math.sin(angle) * distance, 
          opacity: 0,
          width: size,
          height: size
        }}
        transition={{ duration, delay }}
      />
    );
  });

  return (
    <div className="fixed inset-0 pointer-events-none flex items-center justify-center z-50">
      {fireworks}
    </div>
  );
};

export default FireworkAnimation;
